(() => {
  if (window.tdPrivacy) return;
  const key = 'td-advertising-v1', maxAge = 180 * 24 * 60 * 60 * 1000;
  const standalone = document.documentElement.hasAttribute('data-td-standalone');
  let choice = null, loaded = false, returnFocus = null, api = null;
  try {
    const saved = JSON.parse(localStorage.getItem(key));
    if (saved && Date.now() - saved.at < maxAge && ['yes', 'no'].includes(saved.value)) choice = saved.value;
  } catch (_) {}
  const gpc = () => navigator.globalPrivacyControl === true;
  function allowed() {
    if (gpc() || choice !== 'yes') return false;
    if (standalone) return true;
    try { return !!api && api.currentVisitorConsent().marketing === 'yes' && api.marketingAllowed() && api.saleOfDataAllowed(); }
    catch (_) { return false; }
  }
  function loadPixels() {
    if (loaded || !standalone || !allowed() || !/(^|\.)tinydisplays\.ca$/i.test(location.hostname) || window.Shopify?.designMode || document.documentElement.dataset.tdPreview === 'true') return;
    loaded = true;
    if (!window.axon) {
      const pixel = window.axon = function () {
        if (pixel.performOperation) pixel.performOperation.apply(pixel, arguments);
        else pixel.operationQueue.push(arguments);
      };
      pixel.operationQueue = []; pixel.ts = Date.now();
      pixel.eventKey = '25b20a22-e9ec-43d5-8adb-432ff51bdd42';
      ['https://s.axon.ai/pixel.js', 'https://res4.applovin.com/p/l/loader.iife.js'].forEach(url => {
        const script = document.createElement('script'); script.async = true; script.src = url; document.head.appendChild(script);
      });
    }
    try { window.axon('init'); window.axon('track', 'page_view'); } catch (_) {}
    if (!window.fbq) {
      const pixel = window.fbq = function () {
        if (pixel.callMethod) pixel.callMethod.apply(pixel, arguments); else pixel.queue.push(arguments);
      };
      window._fbq = pixel; pixel.push = pixel; pixel.loaded = true; pixel.version = '2.0'; pixel.queue = [];
      const script = document.createElement('script'); script.async = true; script.src = 'https://connect.facebook.net/en_US/fbevents.js'; document.head.appendChild(script);
    }
    try { window.fbq('init', '1956155901666474'); window.fbq('track', 'PageView'); } catch (_) {}
  }
  window.tdPrivacy = {
    allowed,
    trackLead(source) {
      if (!allowed() || !/(^|\.)tinydisplays\.ca$/i.test(location.hostname) || window.Shopify?.designMode || document.documentElement.dataset.tdPreview === 'true') return;
      try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', {content_name: source}); } catch (_) {}
      try { if (standalone && typeof window.axon === 'function') window.axon('track', 'generate_lead', {currency: 'CAD', value: 1}); } catch (_) {}
    }
  };
  function start() {
    const panel = document.getElementById('td-consent');
    if (!panel) return;
    const status = document.getElementById('td-consent-status');
    panel.hidden = choice !== null;
    if (gpc()) status.textContent = 'Global Privacy Control is on. Custom advertising tracking stays off.';
    document.querySelectorAll('[data-td-privacy-open]').forEach(button => button.addEventListener('click', () => {
      returnFocus = button; panel.hidden = false;
      panel.scrollIntoView({block: 'center', behavior: 'instant'});
      panel.querySelector('button').focus();
    }));
    function close() { panel.hidden = true; returnFocus?.focus(); }
    panel.querySelector('[data-td-consent-close]').addEventListener('click', close);
    panel.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
    panel.querySelectorAll('[data-td-consent]').forEach(button => button.addEventListener('click', () => {
      const next = gpc() ? 'no' : button.dataset.tdConsent;
      choice = next;
      try { localStorage.setItem(key, JSON.stringify({value: next, at: Date.now()})); } catch (_) {}
      function finish() {
        status.textContent = next === 'yes' ? 'Advertising preference saved.' : 'Custom advertising tracking is off.';
        if (next === 'no' && loaded) { location.reload(); return; }
        loadPixels(); close();
      }
      // The standalone landing page has no Shopify runtime. Its preference controls its own pixels.
      // Shopify-managed pixels on other pages require separate, verified Shopify permissions.
      if (api) {
        const consent = {marketing: next === 'yes'};
        if (next === 'no') consent.sale_of_data = false;
        try { api.setTrackingConsent(consent, finish); }
        catch (_) { status.textContent = 'Custom preference saved. Shopify could not save its preference; please try again or contact admin@tinydisplays.ca.'; }
      } else finish();
    }));
    if (!standalone && window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
        if (!error) api = window.Shopify.customerPrivacy;
      });
    }
    loadPixels();
  }
  document.addEventListener('visitorConsentCollected', () => {
    if (api && !api.marketingAllowed() && loaded) location.reload();
  });
  window.addEventListener('storage', event => {
    if (event.key === key) location.reload();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
